import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import SectionOne from "./sectionOne/Index";
import MissionSection from "./sectionTwo";
import SectionThree from "./sectionThree/index";
import SectionFour from "./sectionFour/index";
import SectionFive from "./sectionFive";
import SectionSix from "./sectionSix";

const Index = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 800, 
      once: true 
    });
  }, []);

  return (
    <>
      <SectionOne />
      <MissionSection />
      <SectionThree />
      <SectionFour />
      <SectionFive />
      <SectionSix />
    </>
  );
};

export default Index;
